import { render, staticRenderFns } from "./CommonContentSpacer.vue?vue&type=template&id=5d25b980"
import script from "./CommonContentSpacer.vue?vue&type=script&lang=js"
export * from "./CommonContentSpacer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports